// index.jsx - WITH PLANNER ROUTING
import "./index.css"
import App from "./App.js"
import Planner from "./Planner.js" // ADD THIS IMPORT
import { createRoot } from "react-dom/client"
import React from "react"
import { parseUrlConfig } from "./urlConfig"

// Language observer function (invariata)
function createLanguageListener(callback) {
  const languageInput = document.getElementById("conf-language")
  let currentLanguage = languageInput ? languageInput.value : "en"

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === "attributes" &&
        mutation.attributeName === "value"
      ) {
        const newLanguage = languageInput.value
        if (newLanguage !== currentLanguage) {
          console.log(
            `Language changed via attribute: ${currentLanguage} -> ${newLanguage}`
          )
          currentLanguage = newLanguage
          callback(newLanguage)
        }
      }
    })
  })

  if (languageInput) {
    observer.observe(languageInput, { attributes: true })

    setInterval(() => {
      const newValue = languageInput.value
      if (newValue !== currentLanguage) {
        console.log(
          `Language changed via value: ${currentLanguage} -> ${newValue}`
        )
        currentLanguage = newValue
        callback(newValue)
      }
    }, 500)
  }

  return currentLanguage
}

// App rendering
const root = createRoot(document.querySelector("#ayea-player"))

// RENDER FUNCTION WITH ROUTING
const renderPage = () => {
  const hash = window.location.hash || "#/"

  // Check for planner route (supports #/planner and #/planner?preset=...)
  if (hash === "#/planner" || hash.startsWith("#/planner?")) {
    console.log("Rendering Planner")
    root.render(<Planner />)
    return
  }

  // Default: render App with all configurations
  // Parse URL for product code and material config
  const { productCode: urlProductCode, materialConfig } = parseUrlConfig()

  // Fallback to HTML element if no URL product code
  const productIdElement = document.getElementById("ayea-product-id")
  const productId = urlProductCode || (productIdElement ? productIdElement.value : null)

  const urlParams = new URLSearchParams(window.location.search)
  const hashParams = new URLSearchParams(window.location.hash.replace("#", ""))
  const isAdminMode =
    urlParams.get("admin") === "true" ||
    window.location.href.includes("/admin.html") ||
    hashParams.get("admin") === "true" ||
    window.location.hash === "#/admin"

  let appRef = null
  const initialLanguage = createLanguageListener((newLanguage) => {
    if (appRef && appRef.updateLanguage) {
      appRef.updateLanguage(newLanguage)
    }
  })

  console.log("Rendering App with productId:", productId, "materialConfig:", materialConfig)
  root.render(
    <App
      productId={productId}
      isAdmin={isAdminMode}
      language={initialLanguage}
      urlMaterialConfig={materialConfig}
      ref={(ref) => {
        appRef = ref
      }}
    />
  )
}

// Initial render
renderPage()

// Listen for hash changes
window.addEventListener("hashchange", renderPage)

// SEMPLIFICATO: mountAyeaPlayer function
window.mountAyeaPlayer = function mountAyeaPlayer() {
  const mountNode = document.getElementById("ayea-player")
  if (!mountNode) return

  // Parse URL for product code and material config
  const { productCode: urlProductCode, materialConfig } = parseUrlConfig()

  // Fallback to HTML element if no URL product code
  const productId = urlProductCode || document.getElementById("ayea-product-id")?.value
  const language = document.getElementById("conf-language")?.value || "en"

  const hashParams = new URLSearchParams(window.location.hash.replace("#", ""))
  const isAdminMode =
    window.location.hash === "#/admin" || hashParams.get("admin") === "true"

  const modalPlayer = createRoot(mountNode)
  let appRef = null

  createLanguageListener((newLanguage) => {
    if (appRef && appRef.updateLanguage) {
      appRef.updateLanguage(newLanguage)
    }
  })

  modalPlayer.render(
    <App
      productId={productId}
      isAdmin={isAdminMode}
      language={language}
      urlMaterialConfig={materialConfig}
      ref={(ref) => {
        appRef = ref
      }}
    />
  )
}
